import {Message} from "./message";
import {FeedTransport} from "../../_models/feed-transport";

export class CarFeed implements Message {
  transports: FeedTransport[];
}
